import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { TRANSPORTISTAS_API } from "../../../../../shared/services/transportistas";
import { useDispatch } from "react-redux";

export default function TransportistaForm({transportista, isEdit, onCancel, onActionDone}) {
    const dispatch = useDispatch();
    const { register, formState: { errors }, handleSubmit, reset } = useForm({
        defaultValues: {
            id: 0,
            nombre: '',
        }
    });

    useEffect(() => {
        reset(transportista);
    }, [transportista]);

    const handleSubmitTransportista = async(data, e) => {
        e.preventDefault();
        dispatch({type: 'loading/set', payload: true});
        let response;
        
        if(isEdit) {
            response = await TRANSPORTISTAS_API.update(data);
        } else {
            response = await TRANSPORTISTAS_API.new(data);
        }

        if(response && response.data) {
            dispatch({type: 'loading/set', payload: false});
            toast.success(response.message);
            onActionDone();
        }
    }

    const handleCancel = () => onCancel('transportista');
    
    return (
        <div className="w-100 d-flex flex-column mt-4">
            <form className="form flex-row align-items-center mb-4" onSubmit={handleSubmit(handleSubmitTransportista)}>
                <input 
                    type="hidden" 
                    {...register("id")} 
                    defaultValue={isEdit ? transportista.id : ''} />

                <div className="d-flex flex-grow-1">
                    <div className="form-group flex-grow-1 mb-0 me-3">
                        <label htmlFor="nombre">Nombre</label>
                        <input 
                            type="text" 
                            className="form-control"
                            {...register("nombre", { required: true })} 
                            defaultValue={isEdit ? transportista.nombre : 0} />
                        
                        <div className="form-invalid">
                            {errors.nombre?.type === 'required' && "Nombre es obligatorio"}
                        </div>
                    </div>
                </div>

                <div className="d-flex align-items-center align-self-end ms-3">
                    <button type="submit" className="btn btn-primary align-self-end">Guardar</button>
                    <button type="button" className="btn btn-default align-self-end ms-3" onClick={handleCancel}>Cancelar</button>
                </div>
            </form>
        </div>
    )
}